import { darken } from "polished";

import styled from "styled-components";

import metrics from "./metrics";
import colors from "./colors";

export const LoaderContainer = styled.div`
  display: flex;
  align-items: center;

  span {
    margin-left: 10px;
    margin-top: -5px;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: end;
  gap: 15px;
  margin: 25px 0;

  p {
    text-align: right;
  }
`;

export const ProductsTable = styled.table`
  border: 1px solid ${colors.tableColors.border};
  width: 100%;
  margin-bottom: ${metrics.baseMargin}px;

  th {
    background: ${colors.tableColors.header};
    padding: 10px 8px;
    color: ${colors.tableColors.headerText};
    font-weight: 600;
    font-size: 0.95em;
    letter-spacing: 0.5px;
    border-bottom: 2px solid rgba(0, 0, 0, 0.1);
  }
`;

export const ItemLine = styled.tr<{
  $bloqueio?: boolean;
  $lancamento?: boolean;
  $promocao?: boolean;
}>`
  animation: fadeIn 0.4s linear;
  background-color: ${props => {
    if (props.$bloqueio) return colors.bloqueio;
    if (props.$lancamento) return colors.lancamento;
    if (props.$promocao) return colors.promocao;
    return "inherit";
  }};

  td {
    padding: 5px;
    border-bottom: 1px solid ${colors.tableColors.border};
  }

  &:hover {
    background: ${props => {
      if (props.$bloqueio) return darken(0.05, colors.bloqueio);
      if (props.$lancamento) return darken(0.03, colors.lancamento);
      if (props.$promocao) return darken(0.05, colors.promocao);
      return "rgba(0, 0, 0, 0.03)";
    }};
  }
`;

export const QtdColumn = styled.td<{ $estoqueBaixo?: boolean }>`
  width: 70px;

  input {
    background-color: ${props =>
      props.$estoqueBaixo ? colors.errorBg : colors.background.main};
    border: 1px solid ${colors.border.medium};
    border-radius: 4px;
    font-size: 1.1em;
    padding: 5px;
    text-align: right;
    width: 98%;
    transition:
      border-color 0.2s ease,
      box-shadow 0.2s ease;

    &:focus {
      outline: none;
      border-color: ${colors.input.focus};
      box-shadow: 0 0 0 2px ${colors.input.focusShadow};
    }

    &:hover:not(:focus) {
      border-color: ${colors.border.dark};
    }
  }
`;

export const NoQtdColumn = styled.td`
  width: 70px;
  font-size: 1.5em;
  padding: 3px;
  text-align: center;
`;

export const CodColumn = styled.td`
  text-align: center;
`;

export const VlrColumn = styled.td`
  width: 150px;
  text-align: right;
`;

export const WideVlrColumn = styled(VlrColumn)`
  width: 250px;
`;

export const PriceColumn = styled(VlrColumn)`
  width: 250px;
  position: relative;
`;

export const PriceLabel = styled.span`
  text-align: left;
`;
export const PriceValue = styled.span`
  text-align: right;
`;

export const PriceItem = styled.div`
  display: flex;
  justify-content: space-between;
  line-height: 1.5em;
  font-size: 0.8em;
`;

export const AddPriceItem = styled(PriceItem)`
  font-weight: bold;

  & ${PriceValue}::before {
    content: "+ ";
  }
`;

export const SubPriceItem = styled(PriceItem)`
  color: ${colors.successDark};

  & ${PriceValue}::before {
    content: "- ";
  }
`;

export const PriceSuggestionItem = styled.div`
  display: flex;
  justify-content: space-between;
  line-height: 1.5em;
  font-size: 0.9em;
  color: rgba(0, 0, 0, 0.6);
`;

export const PriceItemSeparator = styled.hr`
  margin-bottom: 3px;
`;

export const TotalPriceItem = styled(PriceItem)`
  line-height: 1em;
  font-size: 1em;
`;

export const PaginatorContainer = styled.div`
  display: flex;
  justify-content: center;
`;
